// extracted by mini-css-extract-plugin
export default {"root":"rr8noz","disabled":"D55yIw","typeSquare":"plI5OO","typeCircle":"Q57Sd1","typeNone":"TV5Wwe"};